import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import { BannerStyle } from '../../../../../typings/enums';
import * as IssuesV2Store from '../../../../redux/issuesV2';
import Banner from '../../../generic/Banner';
import VulnerabilityDrawerSection from '../../../shared/vulns/Drawer/Section';
import type { VulnIssue } from '../../../../../shared/issuesV2';

/**
 * Displays a CPE banner.
 */
const CPEBanner: VoidFunctionComponent = () => {
  const activeIssue = useSelector(IssuesV2Store.selectors.getIssueDetails) as VulnIssue;
  if (!(activeIssue?.cpes?.length)) {
    return null;
  }

  const bodyContent = `
    This vulnerability was supplied by the SBOM. Accuracy can not be verified by FOSSA’s analysis. 
    <a href="https://docs.fossa.com/docs/vulnerability-detection-in-sboms" target="_blank">Learn more in our docs</a>.
  `;

  return (
    <VulnerabilityDrawerSection>
      <Banner
        bannerStyle={BannerStyle.Medium}
        title=""
        body={bodyContent}
      />
    </VulnerabilityDrawerSection>
  );
};

export default CPEBanner;
